import React, { useEffect, useContext }from "react";
import useForm from 'react-hook-form';
import Select from "react-select";
import { useTranslation } from 'react-i18next';
import TagsInput from "react-tagsinput";

import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Checkbox from "@material-ui/core/Checkbox";
import FormHelperText from "@material-ui/core/FormHelperText";
import {ValidSelect} from "beaktShared/helpers/validselect";

// icons
import DescriptionIcon from '@material-ui/icons/Description';
import Check from "@material-ui/icons/Check";
import "beaktShared/components/CustomInput/rotate.css";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Clearfix from "beaktShared/components/Clearfix/Clearfix.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";

import { UseGetApiSimple } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
const useStyles = makeStyles(styles);

export default function GrupoCanalMidiaForm({ addItem, item, handleView, loading }) {
    const { t } = useTranslation(); 
    const classes = useStyles();   
    const session = useContext(SessionContext);
     
    const {register, handleSubmit, setValue,setError, errors, clearError } = useForm({mode: "onBlur"});
    const [ativoCheckbox, setAtivoCheckbox] = React.useState(true); 
        
    const [tags, setTags] = React.useState([]);

    const intialValues = {
        grupoCanalMidiaId:0,
        descricao:'',        
        ativo:true,              
    };
       
    useEffect(() => {        
    }, []);   

    useEffect(() => {
        LoadDadosItem(item);    
    }, [item]);

    const LoadDadosItem =(item) =>{        
        if(!item.grupoCanalMidiaId)
            return; 

        setValue('grupoCanalMidiaId', (item.grupoCanalMidiaId === null ? 0 : item.grupoCanalMidiaId));
        setValue('descricao',item.descricao);                
        setValue('ativo',item.ativo);                
        setAtivoCheckbox(item.ativo);        

        let canais = item.canalMidias.filter(f => f.ativo == true).map(m => m.descricao);
        setTags(canais);
    }

    const onSubmit = (data, e) => {        
       e.preventDefault();  
       
       let canais = []
       for(var i in tags){
           canais.push({
            descricao: tags[i],
            ativo: true,
            usuarioCadastroId: session.id            
           });
       }
       
       let item = {
           grupoCanalMidiaId: (data.grupoCanalMidiaId == "" ? 0 : parseInt(data.grupoCanalMidiaId)),
           descricao: data.descricao,
           ativo: ativoCheckbox,
           usuarioCadastroId: session.id,
           franquiaId: session.franquiaId,
           canalMidias: canais
       }

       addItem(item);
    };

    const handleViewForm = () => {
        handleView();
    };

    const handleTags = regularTags => {
        setTags(regularTags);
      };
   
    return (
        <div className="maxContent">             
            <form onSubmit={handleSubmit(onSubmit)}>
                <GridContainer className={classes.marginTopCard}>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="primary" icon>
                                <CardIcon color="primary">
                                    <DescriptionIcon />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>
                                        {t('information_message.media_channel_group_registration')} - <small>{t('information_message.fill_in_your_details')}</small>
                                    <input className={classes.hidden} defaultValue={intialValues.termoServicoId} name="grupoCanalMidiaId" ref={register} />                                
                                </h4>
                            </CardHeader>
                            <CardBody className={classes.cardMargin}>
                                
                            <GridContainer>                                                                                    
                                <GridItem xs={12} sm={8} md={6}> 
                                    <FormControl fullWidth className={classes.formControl}>                               
                                        <TextField                                        
                                            error={errors.descricao?true:false}
                                            label={t('label.description')}
                                            variant="outlined"                                    
                                            inputRef={register({required: true})}
                                            name="descricao"
                                            defaultValue={intialValues.descricao}  
                                            InputLabelProps={{shrink: true}} 
                                            inputProps={{maxLength: 150}}                                      
                                        />
                                    <FormHelperText className={classes.labelRootError}>
                                        {errors.descricao && <span>{t('label.required')}</span>}
                                    </FormHelperText>   
                                    </FormControl>                                 
                                </GridItem>   
                                <GridItem xs={12} sm={4} md={4}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                tabIndex={-1}                                                
                                                checked={ativoCheckbox}   
                                                onClick={event => {setAtivoCheckbox(event.target.checked)}}                                             
                                                checkedIcon={<Check className={classes.checkedIcon} />}
                                                icon={<Check className={classes.uncheckedIcon} />}
                                                classes={{
                                                    checked: classes.checked,
                                                    root: classes.checkRoot
                                                }}                    
                                                name="ativo"  
                                                inputRef={register}                                                    
                                            />
                                        }
                                        classes={{
                                            label: classes.label,
                                            root: classes.labelRoot
                                        }}
                                        label={t('information_message.system_active')}
                                    />
                                </GridItem>                                                                 
                            </GridContainer>
                            <GridContainer>                                                                                    
                                <GridItem xs={12} sm={12} md={12}> 
                                    <FormControl fullWidth className={classes.formControl}>                               
                                        <legend>Canais de Mídia</legend>
                                        <TagsInput
                                            value={tags}                                            
                                            onChange={handleTags}
                                            tagProps={{ className: "react-tagsinput-tag info" }}
                                            inputProps={{placeholder: "Adicionar"}}
                                        />                                    
                                    </FormControl>                                 
                                </GridItem>                                   
                            </GridContainer>                            
                            <Clearfix />
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
            <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                    
                    <div className={classes.textCenter}>
                        <Button  onClick={() => handleViewForm()} color="transparent" className={classes.updateProfileButton}>
                            {t('button.cancel')}
                        </Button>
                        <Button type="submit" color="primary" className={classes.updateProfileButton}>
                            {t('button.to_save')}
                            {loading && <div>...{t('label.loading')}</div>}
                        </Button>
                    </div>
                </GridItem>
            </GridContainer>            
        </form>
    </div>
    );
}
